import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import contactBanner from "../assets/images/page-titles/4.webp";
import logoLight from "../assets/images/logo/logo-light-bg.png";

function ContactUs() {
  const [formData, setFormData] = useState({
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    expertise: "",
    contactMessage: "",
  });

  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(true);
  const [submitStatus, setSubmitStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get API configuration from localStorage
  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";
  const company_id = localStorage.getItem("company_id") || "1";
  const employee_id = localStorage.getItem("employee_id") || "1";

  useEffect(() => {
    // Apply background images
    document.querySelectorAll(".bg-img")?.forEach((el) => {
      const img = el.querySelector("img");
      if (img) {
        const parent = el.parentElement;
        if (parent) {
          parent.style.backgroundImage = `url(${img.src})`;
          parent.style.backgroundSize = "cover";
          parent.style.backgroundPosition = "center";
          parent.classList.add("bg-img");
          if (el.classList.contains("background-size-auto")) {
            parent.classList.add("background-size-auto");
          }
        }
        el.remove();
      }
    });

    // Fetch services for dropdown
    fetchServices();
  }, []);

  // Fetch services from API
  const fetchServices = async () => {
    try {
      setLoadingServices(true);
      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("employee_id", employee_id);
      formData.append("type", "1"); // Type 1 for show all services

      const response = await fetch(`${api_url}service.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1") {
        setServices(data.result || []);
      } else {
        console.error("Failed to fetch services:", data.error);
        // Set default services if API fails
        setServices([{ service_id: "0", service_title: "General Inquiry" }]);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      // Set default services if API fails
      setServices([{ service_id: "0", service_title: "General Inquiry" }]);
    } finally {
      setLoadingServices(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear submit status when user starts typing
    if (submitStatus) {
      setSubmitStatus("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      const submitData = new FormData();
      submitData.append("company_id", company_id);
      submitData.append("employee_id", employee_id);
      submitData.append("type", "3"); // Type 3 for insert
      submitData.append("inquiry_name", formData.contactName);
      submitData.append("inquiry_email", formData.contactEmail);
      submitData.append("inquiry_phone", formData.contactPhone);
      submitData.append("inquiry_service", formData.expertise);
      submitData.append("inquiry_message", formData.contactMessage);

      console.log("Fetching services from API:", `${api_url}service.php`);

      const response = await fetch(`${api_url}inquiry.php`, {
        method: "POST",
        body: submitData,
      });

      const data = await response.json();
      console.log("Form Response", data);

      if (data.status === "1") {
        setSubmitStatus("success");
        // Reset form
        setFormData({
          contactName: "",
          contactEmail: "",
          contactPhone: "",
          expertise: "",
          contactMessage: "",
        });

        // Scroll to top to show success message
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        setSubmitStatus("error");
        console.error("Submission error:", data.error);
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Page Title Section */}
      <section className="page-title-layout1 page-title-light bg-parallax bg-overlay text-center">
        <div className="bg-img">
          <img src={contactBanner} alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 offset-lg-3">
              <h1 className="pagetitle-heading">Request A Free Consultation</h1>
              <nav>
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Request A Free Consultation
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-layout2">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 col-lg-6 col-xl-6">
              <div className="heading-layout2 mb-50">
                <h2 className="heading-subtitle">
                  We help our clients achieve their goals!
                </h2>
                <h3 className="heading-title">
                  Interested in cooperation or have questions? Just fill out the
                  form and we will call you back.
                </h3>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="sticky-top">
                <img src={logoLight} alt="logo" className="mb-50" />
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-6">
              <p className="fz-17 fw-bold color-secondary mb-50">
                Before we get started, we'd like to ask a few questions that
                will help us to better understand your business needs.
              </p>

              {/* Success/Error Messages */}
              {submitStatus === "success" && (
                <div
                  className="alert alert-success mb-30"
                  role="alert"
                  style={{
                    padding: "15px 20px",
                    borderRadius: "8px",
                    backgroundColor: "#d4edda",
                    color: "#155724",
                    border: "1px solid #c3e6cb",
                  }}
                >
                  <strong>Success!</strong> Thank you for your inquiry! We will
                  contact you soon.
                </div>
              )}

              {submitStatus === "error" && (
                <div
                  className="alert alert-danger mb-30"
                  role="alert"
                  style={{
                    padding: "15px 20px",
                    borderRadius: "8px",
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    border: "1px solid #f5c6cb",
                  }}
                >
                  <strong>Error!</strong> Something went wrong. Please try again
                  or contact us directly.
                </div>
              )}

              <div className="contact-panel p-0">
                <form
                  className="contact-panel-form"
                  onSubmit={handleSubmit}
                  id="contactForm"
                >
                  <div className="row">
                    {/* Your Name */}
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="contact-name">
                          Your Name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="John Smith"
                          id="contact-name"
                          name="contactName"
                          value={formData.contactName}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                        />
                      </div>
                    </div>

                    {/* Email Address */}
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="contact-email">
                          Email Address <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="john@example.com"
                          id="contact-email"
                          name="contactEmail"
                          value={formData.contactEmail}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                        />
                      </div>
                    </div>

                    {/* Phone Number */}
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="contact-Phone">
                          Phone Number <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="+1234567890"
                          id="contact-Phone"
                          name="contactPhone"
                          value={formData.contactPhone}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                        />
                      </div>
                    </div>

                    {/* Service (Dynamic Dropdown) */}
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="expertise">
                          Service <span style={{ color: "red" }}>*</span>
                        </label>
                        {loadingServices ? (
                          <select className="form-control" disabled>
                            <option>Loading services...</option>
                          </select>
                        ) : (
                          <select
                            className="form-control"
                            id="expertise"
                            name="expertise"
                            value={formData.expertise}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                          >
                            <option value="">-- Select a Service --</option>
                            {services.map((service) => (
                              <option
                                key={service.service_id}
                                value={service.service_title}
                              >
                                {service.service_title}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    </div>

                    {/* Business Description */}
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="contact-message">
                          Business Description
                        </label>
                        <textarea
                          className="form-control"
                          placeholder="Kindly provide enough information about your business..."
                          id="contact-message"
                          name="contactMessage"
                          value={formData.contactMessage}
                          onChange={handleChange}
                          rows="5"
                          disabled={isSubmitting}
                        ></textarea>
                      </div>

                      {/* Submit Button */}
                      <button
                        type="submit"
                        className="btn btn-secondary same-hover arrow-hover-flip-up mt-30"
                        disabled={isSubmitting}
                        style={{
                          opacity: isSubmitting ? 0.6 : 1,
                          cursor: isSubmitting ? "not-allowed" : "pointer",
                        }}
                      >
                        <span>
                          {isSubmitting ? "Submitting..." : "Submit Request"}
                        </span>
                        {!isSubmitting && (
                          <svg
                            className="arrow-flip"
                            enableBackground="new 0 0 64 64"
                            viewBox="0 0 64 64"
                            width="12"
                            height="12"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g className="arrow-flip-path-1">
                              <path
                                d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                                fill="currentColor"
                              ></path>
                            </g>
                            <g className="arrow-flip-path-2">
                              <path
                                d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                                fill="currentColor"
                              ></path>
                            </g>
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactUs;
